module.exports = __webpack_public_path__ + "static/media/belt.001b76d1.jpg";